import React from 'react';
import { useFormik } from 'formik';
import { Button, Dialog, Grid, TextField } from 'src/components';
import DialogActions from 'src/components/DialogActions';
import DialogContent from 'src/components/DialogContent';
import DialogTitle from 'src/components/DialogTitle';
import kullaniciService from 'src/services/Settings/Generals/kullanici.service';
import { useAppDispatch, useAppSelector } from 'src/store';
import AuthSlice from "src/store/Slices/Base/AuthSlice";
import SnackbarUtils from 'src/utils/SnackbarUtils';
import * as yup from 'yup';
import { translate } from 'src/i18n/tHelper';

interface SifreDegistirProps { }

class PasswordChange {
    newPassword: string = "";
    newPasswordAgain: string = "";
}

const translatePath = "pages|login";
const SifreDegistir = (props: SifreDegistirProps) => {

    const userState = useAppSelector(s => s.userLogin);
    const dispatch = useAppDispatch();

    const pf = useFormik({
        initialValues: new PasswordChange(),
        validateOnChange: false,
        validationSchema: yup.object().shape({
            newPassword: yup.string().nullable().required(translate(translatePath, "Şifre zorunlu alan"))
                .min(4, translate(translatePath, "Şifre minimum 4 karakter olabilir")),
            newPasswordAgain: yup.string().nullable().required(translate(translatePath, "Tekrar şifre zorunlu alan"))
                .oneOf([yup.ref("newPassword")], translate(translatePath, "Şifreler bir biriyle uyuşmuyor"))
        }),
        onSubmit: (e) => {
            kullaniciService.user().then((userRes) => {
                kullaniciService
                    .update({
                        ...userRes.data,
                        sifre: e.newPassword,
                        sifreDegisti: true,
                        yenisifreverildiBool: false
                    })
                    .then((res) => {
                        dispatch(AuthSlice.actions.setNewPassword(false));
                        dispatch(AuthSlice.actions.logOut());
                        SnackbarUtils.success(translate(translatePath, "Şifreniz başarıyla değiştirildi"));
                    });
            });
        }
    })

    return (
        <Dialog
            fullWidth
            open={userState.newPassword}
            maxWidth="sm"
        >
            <DialogTitle>{translate(translatePath, 'Şifre Değiştirme')}</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item md={12}>
                        <TextField
                            required
                            name={'newPassword'}
                            value={pf.values.newPassword}
                            onChange={pf.handleChange}
                            type="password"
                            label={translate(translatePath, 'Yeni Şifre')}
                            error={pf.errors.newPassword ? true : false}
                            helperText={pf.errors.newPassword}
                        />
                    </Grid>
                    <Grid item md={12}>
                        <TextField
                            required
                            name={'newPasswordAgain'}
                            value={pf.values.newPasswordAgain}
                            onChange={pf.handleChange}
                            type="password"
                            label={translate(translatePath, 'Yeni Şifre Tekrar')}
                            error={pf.errors.newPasswordAgain ? true : false}
                            helperText={pf.errors.newPasswordAgain}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button customType="save" onClick={pf.submitForm}>{translate(translatePath, 'Şifre Değiştir')}</Button>
                <Button customType="close" onClick={() => {
                    dispatch(AuthSlice.actions.setNewPassword(false));
                }} />
            </DialogActions>
        </Dialog>
    )
}

export default SifreDegistir